import React, { Fragment, useState } from 'react';
import cn from 'classnames';

import LearnosityProvider from 'legacy-src/utility/LearnosityProvider';
import './index.scss';
import StudentCountIcons from './StudentCountIcons';
import { learnosityReportByUsers } from 'legacy/src/utility/progressHelpers';

const Rubric = ({ reference, isHidden, parentReference }) => (
  <div hidden={isHidden} className={`learnosity-typeset-${parentReference}`}>
    <div className="learnosity-item" data-reference={reference} />
  </div>
);

const Rubrics = (props) => {
  const {
    scoringRubric,
    question,
    partId,
    studentView,
    showStudentCounts,
    learnosityReportsByRubricData,
    assignmentReport,
    studentUrl,
    students,
    onReady = () => {},
    findParentQuestion = () => {},
  } = props;

  const [maxScoreByRubric, setMaxScoreByRubric] = useState({});
  const [itemsAppLoaded, setItemsAppLoaded] = useState(false);

  const onItemsAppReady = (app) => {
    onReady();
    if (!showStudentCounts) {
      return;
    }
    const maxScoreByRubric = {};
    Object.entries(app.getItemScores()).forEach(([reference, score]) => {
      maxScoreByRubric[reference] = score.max_score;
    });
    setMaxScoreByRubric(maxScoreByRubric);
    setItemsAppLoaded(true);
  };

  const rubricsByQuestion = JSON.parse(
    scoringRubric.rubricCategoryReferencesByQuestion,
  );
  const allAssessmentRubrics =
    Object.values(rubricsByQuestion).length === 0
      ? []
      : Object.values(rubricsByQuestion).reduce((acc, curr) =>
          acc.concat(curr),
        );
  const partRubricReference =
    partId &&
    question.children.find((rubric) => rubric.id === partId)
      .learnosityItemReference;
  const { learnosityItemReference: questionReference } = question;
  const currentQuestionRubrics = rubricsByQuestion[questionReference];
  const rubricsToShow = [];

  if (partRubricReference) {
    rubricsToShow.push(partRubricReference);
  } else if (currentQuestionRubrics) {
    rubricsToShow.push(...currentQuestionRubrics);
  }

  return (
    <Fragment>
      <div className={cn('scoring-rubrics', { '--student-view': studentView })}>
        {allAssessmentRubrics.map((rubricReference) => (
          <Fragment key={rubricReference}>
            {showStudentCounts &&
              itemsAppLoaded &&
              learnosityReportsByRubricData &&
              learnosityReportsByRubricData.length && (
                <StudentCountIcons
                  maxScore={maxScoreByRubric[rubricReference]}
                  rubricReference={rubricReference}
                  rubricReportData={learnosityReportByUsers(
                    learnosityReportsByRubricData,
                  )}
                  assignmentReport={assignmentReport}
                  studentUrl={studentUrl}
                  students={students}
                  itemId={questionReference}
                />
              )}
            <Rubric
              parentReference={
                findParentQuestion(rubricReference)
                  ? findParentQuestion(rubricReference).learnosityItemReference
                  : ''
              }
              reference={rubricReference}
              isHidden={!rubricsToShow.includes(rubricReference)}
            />
          </Fragment>
        ))}
      </div>
      {scoringRubric && scoringRubric.learnositySignedRequest && (
        <LearnosityProvider
          initOptions={JSON.parse(scoringRubric.learnositySignedRequest)}
          apiType="items"
          containerElement="learnosity_assess_rubrics"
          readyListener={onItemsAppReady}
        />
      )}
    </Fragment>
  );
};

export default Rubrics;
